// extracted by mini-css-extract-plugin
export var activeFilterButton = "_mf-c";
export var backButton = "_mf-4";
export var backIcon = "_mf-5";
export var chevronShortcut = "_mf-6";
export var container = "_mf-1";
export var editor = "_mf-8";
export var editorWrapper = "_mf-7";
export var prefix = "_mf-2";
export var searchIcon = "_mf-3";
export var suffix = "_mf-9";
export var suffixContent = "_mf-a";
export var suffixText = "_mf-b";
export var wrapper = "_mf-0";